module.exports = __webpack_public_path__ + "static/media/light-motion-constellation-generation.a1c6e57.mp4";